var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        title: "新增/编辑奖品",
        visible: _vm.showVisible,
        "append-to-body": "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showVisible = $event
        },
        close: _vm.closeEdit,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "140px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "奖品类型", prop: "type" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: { disabled: _vm.disabled, placeholder: "请选择" },
                  on: { change: _vm.prizeTypeChange },
                  model: {
                    value: _vm.form.prizeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "prizeType", $$v)
                    },
                    expression: "form.prizeType",
                  },
                },
                _vm._l(_vm.typeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.form.prizeType === 1 || _vm.form.prizeType === 5
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.couponNameStr, prop: "couponName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "text",
                      placeholder: "选择" + _vm.couponNameStr,
                      disabled: "",
                    },
                    model: {
                      value: _vm.form.couponName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "couponName", $$v)
                      },
                      expression: "form.couponName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "margin-left-10",
                      attrs: { disabled: _vm.disabled },
                      on: { click: _vm.openSelectCoupon },
                    },
                    [_vm._v("选择" + _vm._s(_vm.couponNameStr))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "奖品名称", prop: "prizeName" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "text",
                  placeholder: "不超过10个字",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.prizeName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "prizeName", $$v)
                  },
                  expression: "form.prizeName",
                },
              }),
            ],
            1
          ),
          _vm.form.prizeType === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "红包金额", prop: "price" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "number",
                      placeholder: "不超过 200 元",
                      max: 200,
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.form.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "price", $$v)
                      },
                      expression: "form.price",
                    },
                  }),
                  _vm._v("  元\n    "),
                ],
                1
              )
            : _vm._e(),
          _vm.form.prizeType === 1 || _vm.form.prizeType === 5
            ? _c(
                "el-form-item",
                { attrs: { label: "礼包/优惠券金额", prop: "price" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "number", max: 200, disabled: "" },
                    model: {
                      value: _vm.form.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "price", $$v)
                      },
                      expression: "form.price",
                    },
                  }),
                  _vm._v("  金额/个\n    "),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "奖品图片", prop: "prizeImage", required: "" } },
            [
              _c(
                "el-upload",
                {
                  ref: "uploadRef",
                  class: { disabled: _vm.uploadDisabled },
                  staticStyle: { width: "100%" },
                  attrs: {
                    action: _vm.doUpload,
                    headers: _vm.headers,
                    name: "file",
                    "list-type": "picture-card",
                    "before-upload": function (file) {
                      return _vm.handleBeforeUpload(file, 100, 100)
                    },
                    "on-success": function (response, file, fileList) {
                      return _vm.uploadSuccess(response, file, fileList)
                    },
                    limit: 1,
                    "on-error": _vm.handleUploadError,
                    "on-remove": _vm.handleRemove,
                    "file-list": _vm.fileList,
                    "show-file-list": true,
                    data: { code: "activity" },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [_vm._v("建议上传图片尺寸100*100px，不超过500kb。")]
                  ),
                ]
              ),
            ],
            1
          ),
          (_vm.form.prizeType === 1 && _vm.form.couponName) ||
          (_vm.form.prizeType === 5 && _vm.form.couponName)
            ? _c("el-form-item", { attrs: { label: "剩余数量" } }, [
                _vm._v("\n      " + _vm._s(_vm.form.count) + "个\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeEdit } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
      _vm.selectVisible
        ? _c("select-coupon", {
            ref: "selectCoupon",
            attrs: {
              from: "prize-pool",
              title: _vm.selectTitle,
              disable: true,
              selectType: _vm.selectType,
            },
            on: { getCouponItem: _vm.getCouponItem },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }